/**
 * GA4 Event Tracking Module
 *
 * Core analytics functions for tracking user events through Google Analytics 4.
 * gtag.js is loaded by WP Header & Footer plugin - this module only calls gtag().
 */

// ===== CORE =====
function pushGtmEvent(eventName, eventParams = {}) {
	try {
		if (typeof window.gtag === 'function') {
			window.gtag('event', eventName, eventParams);
		} else if (window.dataLayer) {
			window.dataLayer.push({ event: eventName, ...eventParams });
		}
	} catch (e) {
		console.warn('[GA4] Event failed:', eventName, e);
	}
}

export function trackEngagement(eventName, params = {}) {
	pushGtmEvent(`engagement_${eventName}`, params);
}
